<div class="field-container">
  <div class="field-content">
    <div class="attribute-name">
      <b>{{ flatAttribute?.name }}</b>
    </div>

    @if (
      flatAttribute?.hasAttributes || flatAttribute?.hasComplexAttributeValues
    ) {
      <div class="attribute-values">
        @if (!flatAttribute.isComplexField) {
          <div>
            @if (flatAttribute?.isStarRating) {
              <app-star-rating-attribute
                [selectedStarRating]="firstElementValueListItem"
              ></app-star-rating-attribute>
            }
            @if (flatAttribute?.isSkill) {
              <div class="skill-container">
                <skill [selectedSkillLevel]="firstElementValueListItem"></skill>
              </div>
            }
            @if (flatAttribute?.isLongAnswer) {
              @for (attribute of flatAttribute?.attributes; track attribute) {
                <div
                  class="attribute-long-answer"
                  [innerHTML]="attribute.value | safeHtml"
                ></div>
              }
            }
            @if (
              !flatAttribute?.isSkill &&
              !flatAttribute?.isStarRating &&
              !flatAttribute?.isLongAnswer &&
              !flatAttribute?.isDocument &&
              !flatAttribute?.isEncryptedField
            ) {
              @for (value of flatAttribute?.attributes; track value) {
                <span class="displayValues">{{
                  formatDisplayValue(value)
                }}</span>
              }
            }
            @if (flatAttribute?.isEncryptedField) {
              @for (value of flatAttribute?.attributes; track value) {
                <span class="displayValues">***</span>
              }
            }
            @if (flatAttribute?.isDocument) {
              @for (attribute of flatAttribute?.attributes; track attribute) {
                <div class="document-list">
                  @if (flatAttribute?.hasAttributes) {
                    <app-custom-document-viewer
                      [documentAttribute]="attribute"
                      [entityType]="customField.entityType"
                      [entityId]="genericAttributeService?.entityId"
                    ></app-custom-document-viewer>
                  }
                </div>
              }
            }
          </div>
        }
        @if (flatAttribute.isComplexField) {
          <div>
            @for (
              complexAttributeValue of flatAttribute?.complexAttributeValues;
              track complexAttributeValue
            ) {
              <div class="attribute-value">
                <app-complex-field-viewer
                  [complexAttributeValue]="complexAttributeValue"
                ></app-complex-field-viewer>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (
      !flatAttribute?.hasAttributes && !flatAttribute?.hasComplexAttributeValues
    ) {
      @if (effectivelyReadOnly) {
        <span class="empty-value">Empty</span>
      } @else {
        <button
          type="button"
          class="empty-value empty-value-button"
          [attr.aria-label]="'Empty, add ' + flatAttribute?.name"
          (click)="openEditAttributeModal()"
        >
          Empty
        </button>
      }
    }
  </div>
  @if (effectivelyReadOnly) {
    <div class="action-cell">
      @if (
        flatAttribute?.hasAttributes || flatAttribute?.hasComplexAttributeValues
      ) {
        <button
          class="outlined-button"
          mat-icon-button
          [attr.aria-label]="flatAttribute?.name + ' is a read-only field'"
          disabled
        >
          <mat-icon>lock</mat-icon>
        </button>
      }
    </div>
  } @else {
    <div class="action-cell">
      @if (
        !flatAttribute?.hasAttributes &&
        !flatAttribute?.hasComplexAttributeValues
      ) {
        <button
          class="outlined-button"
          mat-icon-button
          [attr.aria-label]="'Add ' + flatAttribute?.name"
          (click)="openEditAttributeModal()"
        >
          <mat-icon>add</mat-icon>
        </button>
      }
      @if (
        flatAttribute?.hasAttributes || flatAttribute?.hasComplexAttributeValues
      ) {
        <div fxLayout="row">
          <button
            mat-icon-button
            class="outlined-button"
            [attr.aria-label]="'Edit ' + flatAttribute?.name"
            (click)="openEditAttributeModal()"
          >
            <mat-icon>edit</mat-icon>
          </button>
          @if (!flatAttribute?.isDocument) {
            <button
              mat-icon-button
              class="outlined-button"
              [attr.aria-label]="'Clear ' + flatAttribute?.name"
              (click)="onClearField()"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
<app-custom-field-editor-modal></app-custom-field-editor-modal>
